import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setToastMessage } from "@actions/global";


const ToastContainer = ({
}) => {
  const dispatch = useDispatch();
  const toastValues = useSelector((state) => state.config.toastValues);

  useEffect(() => {
    if (!!toastValues.message) setTimeout(() => { onClose() }, 2500)
  }, [toastValues])

  const onClose = () => {
    dispatch(setToastMessage(""));
    toastValues.callback && typeof toastValues.callback === "function"
      ? toastValues.callback()
      : null;
  }

  return (
    <div className="toast-popdown-container">
      {!!toastValues.message ?
        <div
          className={`toast-popdown-redux-component top-[100px] bottom-[auto] left-1/2 text-white
         font-body bg-[rgb(49_49_49)] flex-wrap fixed z-[1400] py-[6px] px-[16px] flex w-[288px] justify-center`}
          data-testid="toast-popdown-redux-message">
          <div className="justify-center font-normal flex-wrap text-sm tracking-[0.01071em] py-[6px]">
            {toastValues.message}
          </div>
        </div> : <></>}
    </div>
  );
};



export default ToastContainer;